import React, { useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { Drawer, List as AList, Row, Col, Empty } from 'antd';
import { StyledTitle as Title } from '../../../fields/Title';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { TutorGroupQuestionSetItem } from './TutorGroupQuestionSetItem';
import { FormattedMessage, useIntl } from 'react-intl';

export const StyledContainer = styled.div`
  display: block;
  margin-bottom: 20px;
  padding: 30px;
  width: 100%;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.31);
`;

const StyledDivider = styled.div`
  width: 100%;
  height: 1px;
  margin: 10px 0;
`;

const StyledEmptyDescription = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const StyledSubtitle = styled.span`
  display: inline-block;
  width: 100%;
  font-size: 14px;
  color: #000000;
  margin-bottom: 20px;
`;

export const TutorGroupQuestionSetsListDrawer = ({
  tutorGroupQuestionSets = [],
  questionSets = [],
  onClose,
  visible,
  remove,
  push
}) => {
  const availableQuestionSets = useMemo(() => {
    let filteredQuestionSets = [];

    questionSets?.forEach((qSet) => {
      const foundQuestionSet = tutorGroupQuestionSets?.find(
        ({ id }) => id === qSet.id
      );

      if (foundQuestionSet) {
        filteredQuestionSets = [...filteredQuestionSets];
      } else {
        filteredQuestionSets = [...filteredQuestionSets, qSet];
      }
    });

    return filteredQuestionSets;
  }, [questionSets, tutorGroupQuestionSets]);

  const removeQuestionSetOnClick = useCallback(
    ({ event, qSet, index }) => {
      console.log('removeStudentOnClick, event: ', event);
      console.log('removeStudentOnClick, qSet: ', qSet);

      event.preventDefault();
      event.stopPropagation();

      remove(index);
    },
    [remove]
  );

  const addQuestionSetOnClick = useCallback(
    ({ event, qSet, index }) => {
      console.log('addQuestionSetOnClick, event: ', event);
      event.preventDefault();
      event.stopPropagation();

      push(qSet);
    },
    [push]
  );
  const intl = useIntl();
  return (
    <Drawer
      title={intl.formatMessage({ id: 'tutor-group.question-sets-drawer.title' })}
      placement='right'
      width={window.innerWidth > 600 ? 600 : window.innerWidth}
      onClose={onClose}
      visible={visible}
    >
      <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}>
        <Col style={{ width: '100%' }}>
          <Title level={5}><FormattedMessage id="tutor-group.question-sets-drawer.subTitle"/></Title>
          <StyledSubtitle>
            <FormattedMessage
              id="tutor-group.question-sets-drawer.totalQuestionsAdded"
              values={{ total: `${tutorGroupQuestionSets.length ?? 0}/3` }}
            />
          </StyledSubtitle>
          <AList
            itemLayout='horizontal'
            dataSource={tutorGroupQuestionSets}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={
                    <StyledEmptyDescription>
                      <span><FormattedMessage id="tutor-group.emptyState.noQuestions"/></span>
                      <span>
                        <FormattedMessage id="tutor-group.emptyState.addQuestions"/>
                      </span>
                    </StyledEmptyDescription>
                  }
                />
              )
            }}
            renderItem={(qSet, index) => (
              <TutorGroupQuestionSetItem
                qSet={qSet}
                index={index}
                onClick={removeQuestionSetOnClick}
                icon={<MinusOutlined />}
              />
            )}
          />
        </Col>
      </Row>
      <StyledDivider />
      <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}>
        <Col style={{ width: '100%' }}>
          <Title level={5}><FormattedMessage id="tutor-group.question-sets-drawer.myQuestionSets"/></Title>
          <StyledSubtitle>
            <FormattedMessage
              id="tutor-group.question-sets-drawer.questionSetsAvailable"
              values={{ total: `${availableQuestionSets.length ?? 0}` }}
            />
          </StyledSubtitle>
          <AList
            itemLayout='horizontal'
            dataSource={availableQuestionSets}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={
                    <StyledEmptyDescription>
                      <span>
                        <FormattedMessage id="tutor-group.emptyState.noQuestionSets" />
                      </span>
                    </StyledEmptyDescription>
                  }
                />
              )
            }}
            renderItem={(qSet, index) => (
              <TutorGroupQuestionSetItem
                qSet={qSet}
                count={tutorGroupQuestionSets?.length}
                maxCount={3}
                index={index}
                onClick={addQuestionSetOnClick}
                icon={<PlusOutlined />}
              />
            )}
          />
        </Col>
      </Row>
    </Drawer>
  );
};
